import { createContext } from 'react';

import type UserManagementService from 'services/userManagement/userManagementService';
import UserManagementServiceImpl from 'services/userManagement/userManagementServiceImpl';
import { type AuthenticatedUserInterface } from 'typedefs/authTypes';

interface UserManagementContextProps {
  user?: AuthenticatedUserInterface;
  loading: boolean;
}

export const UserManagementContext = createContext<UserManagementContextProps>(null);
export const UserManagementServiceContext = createContext<UserManagementService>(UserManagementServiceImpl);
